<template>
  <div class="add_item">
    <span class="item_title">运营</span>
    <el-select
      v-model="addParameter.fs_open_id"
      default-first-option
      filterable
      :loading-text="加载中"
      :loading="loading"
      placeholder="请选择"
      @keyup.native="handleSelectChange"
    >
      <el-option
        v-for="item in tableData"
        :key="item.openId"
        :label="item.name"
        :value="item.openId"
      />
    </el-select>
    <el-button
      type="primary"
      style="margin-left: 10px"
      @click="addPitcher"
    >连接飞书人员</el-button>
  </div>
</template>

<script>
import { workWechatKfV3FsLists, workWechatKfV3SetFsOpenId } from '@/api/providerAccountManagement/servicePorviderList2.js'
export default {
  components: {
  },
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    },
    getlist: {
      type: Function
    }
  },
  data() {
    return {
      tableData: [],
      tableDatas: [],
      parameter: {
        page: 1,
        pageSize: 10,
        name: '',
        open_id: ''
      },
      addParameter: {
        id: this.drawerItem.id,
        fs_open_id: ''
      },
      timer: true,
      loading: false
    }
  },

  created() {
    this.getDataList()
  },
  mounted() {

  },
  methods: {
    closes() {
      this.addParameter = {
        id: '',
        fs_open_id: ''
      }
      this.tableData = []
      this.parameter.open_id = ''
    },
    async handleSelectChange(e) {
      if (this.timer) {
        clearTimeout(this.timer) // 清除之前的计时器
      }
      this.loading = true
      this.timer = setTimeout(async() => {
        console.log(1, e.target.value)
        this.parameter.open_id = ''
        this.parameter.name = e.target.value
        const data = await workWechatKfV3FsLists(this.parameter)
        this.tableData = data.data.list
        console.log(this.tableData, 'this.tableData')
        this.loading = false
      }, 1000) // 等待1秒执行
    },
    // 获取数据列表
    async getDataList() {
      this.addParameter.fs_open_id = ''
      this.parameter.open_id = this.drawerItem.fs_open_id
      const res = await workWechatKfV3FsLists(this.parameter)
      this.tableData = res.data.list
      res.data.list.forEach(item => {
        if (item.openId === this.drawerItem.fs_open_id) {
          this.addParameter.fs_open_id = item.openId
          this.newid = this.drawerItem.fs_open_id
        }
      })
    },

    // 添加投手
    async addPitcher() {
      console.log(this.newid)
      if (this.addParameter.fs_open_id === '') {
        1
      }
      let text = null
      this.addParameter.fs_open_id || (text = '请选择飞书人员')
      text || await workWechatKfV3SetFsOpenId(this.addParameter)
      text || this.getDataList()
      text || (this.addParameter.fs_open_id = null)
      this.$message({
        message: text || '连接飞书人员成功',
        type: text ? 'warning' : 'success'
      })
      this.getlist()
    }

  }
}
</script>

<style scoped>
.add_item {
  margin-bottom: 500px;
}

.item_title {
  display: inline-block;
  width: 50px;
}
</style>
